export const SESSION_ID_STORAGE_KEY = 'icom-mock.session-id'
export const SESSION_ID_HEADER = 'x-icom-mock-session-id'

function createSessionId() {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID()
  }

  return `session-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`
}

export function getOrCreateSessionId() {
  if (typeof window === 'undefined') {
    return ''
  }

  const existing = window.localStorage.getItem(SESSION_ID_STORAGE_KEY)
  if (existing) {
    return existing
  }

  const created = createSessionId()
  window.localStorage.setItem(SESSION_ID_STORAGE_KEY, created)
  return created
}

export function getSessionBaseUrl(sessionId = getOrCreateSessionId()) {
  if (typeof window === 'undefined') {
    return `/s/${sessionId}`
  }

  return `${window.location.origin}/s/${sessionId}`
}

export async function api<T>(method: string, path: string, body?: object) {
  const sessionId = getOrCreateSessionId()
  const headers = new Headers()
  if (sessionId) headers.set(SESSION_ID_HEADER, sessionId)
  if (body) headers.set('Content-Type', 'application/json')

  const opts: RequestInit = {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  }
  const res = await fetch(path, opts)
  const data = (await res.json().catch(() => null)) as T | null
  return { ok: res.ok, status: res.status, data }
}

export function prettyJson(data: unknown) {
  return JSON.stringify(data, null, 2)
}
